export const LoginStart = 'login/LOGIN_START';
export const LoginSuccess = 'login/LOGIN_SUCCESS';
export const LoginError = 'login/LOGIN_ERROR';
export const SignOut = 'login/SIGN_OUT';
